export class QuartzSchedule {
    constructor({
        id = null,
        methodReference = null,
        params = null,
        cronExpression = null,
        status = null,
        description = null,
        createTime = null,
        module = null,
        jobName = null,
    } = {}) {
        this.id = id,
        this.methodReference = methodReference,
        this.params = params,
        this.cronExpression = cronExpression,
        this.status = status,
        this.description = description,
        this.createTime = createTime,
        this.module = module,
        this.jobName = jobName
    }
}
export function gridFields() {
    return Object.freeze([
        // {
        //     key: 'id',
        //     label: 'quartz.scheduleJob.id',
        //     sortable: true,
        //     form: {
        //         type: 'input'
        //     }         
        // },
        {
            key: 'jobName',
            label: 'quartz.scheduleJob.jobName',
            sortable: true,
            form: {
                type: 'input'
            }         
        },
        {
            key: 'module',
            label: 'quartz.scheduleJob.module',
            sortable: true,
            form: {
                type: 'input'
            }         
        },
        {
            key: 'methodReference',
            label: 'quartz.scheduleJob.methodReference',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'cronExpression',
            label: 'quartz.scheduleJob.cronExpression',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'status',
            label: 'quartz.scheduleJob.status',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    { value: 1, text: '启动' },
                    { value: 0, text: '暂停' }
                  ]
            }
        },
        {
            key: 'description',
            label: 'quartz.scheduleJob.description',
            sortable: true,
            form: {
                type: 'input'
            }         
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new QuartzSchedule()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.jobName',
    'filter.module',
    'filter.methodReference',
    'filter.status',
];

export const filter = {
    'jobName': "",
    'module': "",
    'methodReference': "",
    'status': ""
};